
$(document).ready(function(){
  var slidesInView = $('.collection-list__slider').data('products-in-view');
  $('.collection-list__slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: slidesInView,
    slidesToScroll: slidesInView,
    prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/larrow.png?v=91120459931114269961774905676"></div>',
    nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/rarrow.png?v=95456879295688143981774905676"></div>',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      }
    ]
  });
  var slidesInView = $('.featured-collection__slider').data('products-in-view');
  $('.featured-collection__slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: slidesInView,
    slidesToScroll: slidesInView,
    prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/larrow.png?v=91120459931114269961774905676"></div>',
    nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/rarrow.png?v=95456879295688143981774905676"></div>',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      }
    ]
  });

  setTimeout(function(){
    $(".product-recommendations__slider").show();
    var slidesInView = $('.product-recommendations__slider').data('products-in-view');
    $('.product-recommendations__slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: slidesInView,
      slidesToScroll: slidesInView,
      prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/larrow.png?v=91120459931114269961774905676"></div>',
      nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/rarrow.png?v=95456879295688143981774905676"></div>',
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        }
      ]
    });
  }, 3000);
});

// $('.fcwi__slider').slick({
//   dots: false,
//   arrows: true,
//   infinite: true,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/larrow.png?v=91120459931114269961774905676"></div>',
//   nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/rarrow.png?v=95456879295688143981774905676"></div>',
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         arrows: false
//       }
//     }
//   ]
// });

$('.slideshow-with-products__slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  fade: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.product-list-container',
  prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/larrow.png?v=91120459931114269961774905676"></div>',
  nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/rarrow.png?v=95456879295688143981774905676"></div>'
});
$('.product-list-container').slick({
  dots: false,
  arrows: false,
  infinite: true,
  asNavFor: '.slideshow-with-products__slider',
  focusOnSelect: true,
  fade: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

 $('.product-area__mainphoto').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
   prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/larrow.png?v=91120459931114269961774905676"></div>',
  nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/rarrow.png?v=95456879295688143981774905676"></div>',
  asNavFor: '.product-area__thumbnails'
});
$('.product-area__thumbnails').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  asNavFor: '.product-area__mainphoto',
  dots: true,
  centerMode: true,
  prevArrow: '<div class="larrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/larrow.png?v=91120459931114269961774905676"></div>',
  nextArrow: '<div class="rarrow"><img src="//furbishstudio.com/cdn/shop/t/252/assets/rarrow.png?v=95456879295688143981774905676"></div>',
  focusOnSelect: true,
  infinite:true
});

$(document).ready(function(){
  if($(window).width() < 768){
    $(".image-with-text .image-with-text__text .image-with-text__text__wrap").css("max-width", $(window).width());
  }
});

$(".product-area__mainphoto .main-item").click(function(){
  $.magnificPopup.open({
    items: {
      src: '#product-image-modal'
    },
    type: 'inline',
    callbacks: {

        open: function() {                       
            $('body').addClass('disableScroll');  
        },                                        

        close: function() {                      
            $('body').removeClass('disableScroll'); 
        },                                        

    }
  });
});

function getMaxChildWidth(sel) {
    max = 0;
    $(sel).children().each(function(){
        c_width = parseInt($(this).width());
        if (c_width > max) {
            max = c_width;
        }
    });
    return max;
}
$('.cc-announcement .marquee-text .cc-announcement__inner').css('min-width', getMaxChildWidth('#site-control.fixed .cc-announcement'));

  var w = $(window).width()/3 - 40;
  if(w > 550){
    w = 550;
  }
  var border = $(".slideshow--border-left .slide .rimage-outer-wrapper.desktop-only .icon-slideshow-border").width();
  var l = w + (border - w) - 40;
  $(".slideshow--border-left .slide .rimage-outer-wrapper.desktop-only").css("margin-left", w+"px");
  $(".slideshow--border-left .slide .rimage-outer-wrapper.desktop-only .slideshow--border").css("left", -l+"px");
  if($(window).width() > 991){
    $(".slideshow--border-left .slide .overlay .inner").css("width", w-60 +"px");
  }

$(window).resize(function(){
  var w = $(window).width()/3 - 40;
  if(w > 550){
    w = 550;
  }
  var border = $(".slideshow--border-left .slide .rimage-outer-wrapper.desktop-only .icon-slideshow-border").width();
  var l = w + (border - w) - 40;
  $(".slideshow--border-left .slide .rimage-outer-wrapper.desktop-only").css("margin-left", w+"px");
  $(".slideshow--border-left .slide .rimage-outer-wrapper.desktop-only .slideshow--border").css("left", -l+"px");
  if($(window).width() > 991){
    $(".slideshow--border-left .slide .overlay .inner").css("width", w-60 +"px");
  }
});